import {
  ApplicationConfig,
  isDevMode,
  provideZoneChangeDetection,
  inject,
  provideAppInitializer,
  ErrorHandler,
} from '@angular/core';
import {
  provideRouter,
  Router,
  withHashLocation,
  withViewTransitions,
} from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideToastr } from 'ngx-toastr';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import {
  HTTP_INTERCEPTORS,
  HttpBackend,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
  withJsonpSupport,
} from '@angular/common/http';
import { HttpLoaderFactory } from './core/utils/loader-factory';
import { environment } from '../environments/environment';

import { AppUpdateService, reducer, StorageService } from '@kimbocare/core';
import { provideServiceWorker } from '@angular/service-worker';
import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideCacheableAnimationLoader,
  provideLottieOptions,
} from 'ngx-lottie';
import player from 'lottie-web';
import { TraceService } from '@sentry/angular';
import * as Sentry from '@sentry/angular';
import { provideStore } from '@ngrx/store';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions(), withHashLocation()),
    provideAnimations(),
    provideClientHydration(),
    provideToastr({
      preventDuplicates: true,
    }),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withJsonpSupport()
    ),
     provideStore(
      { appState: reducer },
      {
       runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: false,
        },
      }
    ),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend],
      },
    }),
    provideLottieOptions({ player: () => player }),
    provideCacheableAnimationLoader(),
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    { provide: 'env', useValue: environment },
    StorageService,
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
    AppUpdateService,
    provideAppInitializer(() => {
      const initializerFn = (
        (ds: AppUpdateService) => () =>
          ds.init()
      )(inject(AppUpdateService));
      return initializerFn();
    }),
  ],
};
